import { YOU_HAVE_BEEN_SUCCESSFULLY_REGISTERED } from 'mk/autogenerated/translations/Signup.sagas.0edfad86013d05f01be13226e212c033'
import {
    bazaar_single_page_product_grid_url,
    users_api_auth_signup_url,
    users_api_auth_validate_inputs_url,
} from 'mk/urls/functions';
import {
    SIGNUP_TRIGGER,
    signupAPI,
    SignupNormalizedResponse,
    SignupTriggerAction,
    VALIDATE_REGISTRATION_INPUTS_TRIGGER,
    validateRegistrationInputsAPI,
    ValidateRegistrationInputsTriggerAction,
} from 'mk2/apps/users/containers/Signup/Signup.actions';
import { SIGNUP_FORM_NAME } from 'mk2/apps/users/containers/Signup/Signup.constants';
import { gotoUrlAfterLoginOrSignup, storeLastKnownUsernameCookie } from 'mk2/apps/users/utils';
import { FormPageType } from 'mk2/constants';
import { normalizeError, XHRAction, XHRFormError } from 'mk2/helpers/api';
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { mkReduxFormOpenPage } from 'mk2/helpers/form.actions';
import { getLogger } from 'mk2/logger';
import { getRequestBaseUrl } from 'mk2/reducers';
import { UserEntity, UserSchema } from 'mk2/schemas';
import { getRoutingLocation } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { normalize } from 'normalizr';
import { touch } from 'redux-form';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

const logger = getLogger('home/Signup.sagas');

interface ApiResponseSignup {
    body: {
        user: UserEntity;
    };
}

function* signup({signupFd, query, iframe, newSignupForm, xhr}: SignupTriggerAction & XHRAction) {
    yield put(signupAPI.request(signupFd, query, newSignupForm));

    try {
        const response: ApiResponseSignup = yield call(
            () => xhr.post(users_api_auth_signup_url(), {
                signupFd,
                query,
                newSignupForm,
            }),
        );

        const normalizedResponse: SignupNormalizedResponse = normalize(response.body, {user: UserSchema});
        storeLastKnownUsernameCookie(response.body.user.username);

        const msg = interpolate(YOU_HAVE_BEEN_SUCCESSFULLY_REGISTERED, {username: response.body.user.username});
        const baseUrl = yield select(getRequestBaseUrl);
        const location = yield select(getRoutingLocation);
        const gotoUrl = gotoUrlAfterLoginOrSignup(baseUrl, location, bazaar_single_page_product_grid_url());

        if (iframe) {
            // redirect parent page of iframe
            window.top.location.href = gotoUrl;
        }
        yield handleXHRFormSuccessSaga(SIGNUP_FORM_NAME, gotoUrl, msg);
        yield put(signupAPI.success(signupFd, normalizedResponse));
    } catch (error) {
        yield handleXHRFormErrorSaga(SIGNUP_FORM_NAME, error as XHRFormError, logger);
        yield put(signupAPI.failure(signupFd, normalizeError(error)));
    }
}

function* validateInputs({signupFd, query, xhr}: ValidateRegistrationInputsTriggerAction & XHRAction) {
    yield put(validateRegistrationInputsAPI.request(signupFd, query));
    yield put(touch(SIGNUP_FORM_NAME, 'dueDate'));
    try {
        const response = yield call(
            () => xhr.post(users_api_auth_validate_inputs_url(), {
                signupFd,
                query,
            }),
        );

        yield put(validateRegistrationInputsAPI.success(signupFd, response));
        yield put(mkReduxFormOpenPage(SIGNUP_FORM_NAME, FormPageType.SignupPhoneVerification));

    } catch (error) {
        yield handleXHRFormErrorSaga(SIGNUP_FORM_NAME, error as XHRFormError, logger);
        yield put(validateRegistrationInputsAPI.failure(signupFd, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(SIGNUP_TRIGGER, signup),
        takeLatest(VALIDATE_REGISTRATION_INPUTS_TRIGGER, validateInputs),
    ]);
}
